
import userService from "./userService";
import adminService from "./adminService";
import orderService from "./orderService";
import productService from "./productService";
import clientService from "./clientService";
import addressService from "./addressService";
import cancelReasonService from "./cancelReasonService";
import couriersReportsService from "./couriersReportsService";
import dashboardService from "./dashboardService";
import mapService from "./mapService";

const services = {
  user: userService,
  admin: adminService,
  order: orderService,
  product: productService,
  client: clientService,
  address: addressService,
  cancelReason: cancelReasonService,
  couriersReports: couriersReportsService,
  dashboard: dashboardService,
  map: mapService,
};

export const serviceFactory = {
  get: name => services[name]
};



// WEBPACK FOOTER //
// ./src/apiServices/serviceFactory.js